import { calculateDifferenceInDays } from '../../views/MarketingMixModeling/parts/time';

/**
 * Calculates average spend statistics from training data
 * @param {Array<Object>} selectedData - Array of selected data points
 * @param {Array<Object>} trainingData - Array of all training data points
 * @returns {Object} Object containing average spend statistics for each feature
 */
export const calculateStatsFromTrainingData = (selectedData, trainingData) => {
  if (selectedData.length === 0) {
    return Object.keys(trainingData[0])
      .reduce((accu, key) => {
        if (key === 'date') return accu;
        accu[key] = { currentSpend: 0 };
        return accu;
      }, {});
  }

  const total = selectedData.reduce((accu, row) => {
    Object.keys(row).forEach(key => {
      if (key === 'date') return;
      accu[key] = (accu[key] || 0) + row[key];
    });
    return accu;
  }, {});

  return Object.keys(total).reduce((accu, key) => {
    accu[key] = { currentSpend: parseInt(total[key] / selectedData.length / 50) * 50 };
    return accu;
  }, {});
};

/**
 * Transforms cube response data into daily average spend by feature
 * @param {Array<Object>} resp - Response data from cube query
 * @param {Object} featureIDMap - Mapping of friendly names to feature IDs
 * @param {Array<string>} dates - Array of [startDate, endDate] in ISO format
 * @returns {Object} Object containing average daily spend for each feature
 */
export const transformCubeResponse = (resp, featureIDMap, dates) => {
  const numDays = calculateDifferenceInDays(dates[0], dates[1]) + 1;

  const transformed = resp.reduce((accu, item) => {
    const friendlyName = item['spend_mta_with_mmm_features.mmm_friendly_name'];
    const spend = Number(item['spend_mta_with_mmm_features.spend']);
    const featureId = friendlyName === 'Unclassified Spend' || !featureIDMap[friendlyName]
      ? 'Unclassified Spend'
      : featureIDMap[friendlyName];

    if (!(featureId in accu)) {
      accu[featureId] = 0;
    }
    accu[featureId] += spend;
    return accu;
  }, {});

  return Object.keys(transformed).reduce((accu, key) => {
    accu[key] = {
      currentSpend: (transformed[key] || 0) / numDays,
    };
    return accu;
  }, {});
};
